import { AppModuleCode, PermissionCode } from '@gb-ticket/shared-types';
import { Loader2Icon } from 'lucide-react';
import { NavLink, Navigate, Outlet, useLocation } from 'react-router';

import { hasPermission, isModuleEnabled } from '@/features/auth/permissions';
import { useMe } from '@/features/auth/use-me';
import { AppLogoLink } from '@/platform/components/app-logo-link';
import { PlatformChrome } from '@/platform/components/platform-chrome';
import { PortalChatWidget } from '@/products/helpdesk/features/portal/portal-chat-widget';
import { PORTAL_ROOT } from '@/products/helpdesk/features/portal/portal-paths';
import { isTicketListPath } from '@/products/helpdesk/features/tickets/ticket-list-path';
import '@/products/helpdesk/product-nav';

export function PortalLayout() {
  const me = useMe();
  const location = useLocation();
  const canUseAgentUi = hasPermission(me.data, PermissionCode.TICKETS_READ_ALL);
  const showPortalChat = isModuleEnabled(me.data, AppModuleCode.AI);

  if (me.isPending) {
    return (
      <p className="flex min-h-svh items-center justify-center gap-2 text-muted-foreground">
        <Loader2Icon className="size-4 animate-spin" aria-hidden />
        Wird geladen …
      </p>
    );
  }

  if (!me.data) {
    const from = `${location.pathname}${location.search}`;
    return <Navigate to={`/anmelden?from=${encodeURIComponent(from)}`} replace />;
  }

  return (
    <PlatformChrome
      brand={
        <div className="flex min-w-0 items-center gap-2.5">
          <AppLogoLink imageClassName="h-8 w-auto sm:h-9" />
          <NavLink
            to={PORTAL_ROOT}
            className="block text-sm leading-tight font-semibold text-primary sm:text-base"
          >
            IT-Hilfe
          </NavLink>
        </div>
      }
      mainClassName={isTicketListPath(location.pathname) ? 'py-4 md:py-5' : 'py-8'}
      footerLabel="IT-Hilfe"
      userMenuProps={{ showAgentLink: canUseAgentUi, showPortalHomeLink: true }}
      after={showPortalChat ? <PortalChatWidget /> : null}
    >
      <Outlet />
    </PlatformChrome>
  );
}
